<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary" icon="eye">

        </a-button>

        <a-modal width="1000px" v-model="visible" title="  مشاهده درخواست" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>


            <template>
                <a-card title="اطلاعات درخواست " class="text-right ">
                    <a-card-grid style="width: 50%; text-align: center">{{info.user ?  $root.full_name(info . user . firstname , info . user . lastname) : '' }}</a-card-grid>
                    <a-card-grid style="width: 50%; text-align: center">کاربر</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center"> {{info.user ? new Date(info.user.created_at) . toLocaleDateString('fa-IR') : '' }}</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center">تاریخ عضویت</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center"> {{info.user ? $root.number_format(info.user.investment) : '' }}</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center">سرمایه اولیه</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center"> {{info.user ? $root.number_format(info.user.wallet) : '' }}</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center">موجودی کیف پول</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center"> {{info.user ? $root.number_format(info.user.barter) : '' }}</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center">موجودی تهاتری</a-card-grid>



                    <a-card-grid style="width: 50%; text-align: center">

                        <b-badge pill v-if="info.status == 'success'" variant="info" class="bg-success">
                            {{ info . status }}
                        </b-badge>
                        <b-badge pill v-else-if="info.status == 'pending'" variant="warning" class="bg-warning">
                            {{ info . status }}
                        </b-badge>
                        <b-badge pill v-else variant="danger" class="bg-danger">
                            {{ info . status }}
                        </b-badge>

                    </a-card-grid>
                    <a-card-grid style="width: 50%; text-align: center">وضعیت</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center">{{ info . description }}</a-card-grid>
                  <a-card-grid style="width: 50%; text-align: center">توضیحات</a-card-grid>
                </a-card>
            </template>


          <section class="w-100 p-4 text-right ">
            <a-card title="تراکنش های مربوط به درخواست لغو عضویت">
              <div class="table-responsive">

                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th scope="col"> تاریخ</th>
                    <th scope="col"> توضیحات</th>
                    <th scope="col">  نوع حساب</th>
                    <th scope="col">نوع تراکنش</th>
                    <th scope="col">مقدار</th>

                    <th scope="col">شناسه</th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in info.transactions">
                    <td>
                      <p>
                        {{new Date(row.created_at).toLocaleDateString('fa-IR')}}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{row.description}}
                      </p>
                    </td>
                    <td>
                      <b-badge v-if="row.account == 'barter'"  pill variant="info" class="bg-dark">
                        تهاتری
                      </b-badge>
                      <b-badge v-else-if="row.account == 'wallet'"  pill variant="info" class="bg-dark">
                        کیف پول
                      </b-badge>
                      <b-badge v-else pill variant="info" class="bg-dark">
                        سرمایه اولیه
                      </b-badge>
                    </td>

                    <td>
                      <b-badge v-if="row.type == 'in'" variant="light" class="bg-success">
                        ورودی</b-badge>

                      <b-badge v-else variant="light" class="bg-danger">
                        خروجی</b-badge>

                    </td>
                    <td>
                      <b-badge variant="light" class="text-dark">
                        {{ $root . number_format(row.amount) }}
                      </b-badge>
                    </td>

                    <th scope="row">#{{ row.id }}</th>

                  </tr>
                  </tbody>
                </table>
              </div>

            </a-card>
          </section>


            <form @submit.prevent="addData($event)" v-show="$root.hasPermission('/requests/status/') && info.status =='pending'">

                <div class="row text-right mt-md-5">
                    <h6> تغییر وضعیت درخواست</h6>
                    <hr />
                    <div class="col-md-8 my-1"></div>
                    <div class="col-md-4 my-1">
                        <label class="sr-only" for="inline-form-input-name"> وضعیت درخواست</label>
                        <select  class="form-control" name="status">
                            <option value="">انتخاب</option>
                            <option value="pending"> درانتظار</option>
                            <option value="success">قبول شده</option>
                            <option value="denied">رد شده </option>
                        </select>
                    </div>

                    <div class="col-md-1 my-1">
                        <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success ">
                            ذخیره
                        </button>
                    </div>
                </div>
            </form>
        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            info: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
            };
        },
        methods: {
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                this.loading = true;
                let url = `/cancellation-request/status/${this.info.id}`
                axios
                    .post(url, data)
                    .then(function(response) {
                        _this.loading = false;
                        _this.$toast.success("  درخواست با موفقیت ویرایش شد");
                    })
                    .catch(function(err) {
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')
            },
        }
    };
</script>
